import { RECEIVED_NEXT_STEP_PROGRESS } from '../actions/GetNextStepProgress';

const initialState = {
  teamHasProduct: false,
  userHasSentInvite: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIVED_NEXT_STEP_PROGRESS:
      return action.nextStepProgress;
    default:
      return state;
  }
};
